/**
 * BuyIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BuyIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m22.99 8.918-10.5-7a1 1 0 0 0-1.1 0l-10.45 7c-.4.32-.49.9-.21 1.33s.85.57 1.31.33l.9-.63v11.3c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-11.3l.95.63c.16.11.35.17.55.17.44 0 .82-.29.95-.71s-.04-.87-.4-1.12m-4.05 11.33h-14V8.617l7-4.67 7 4.67z" />
    <path d="M11.15 7.588v.32h-.36c-1.4 0-2.55 1.18-2.55 2.63 0 1.69.98 2.23 1.73 2.49l1.19.41v2.63h-.12c-.6 0-1.09-.53-1.09-1.19a.85.85 0 1 0-1.7 0c0 1.59 1.25 2.89 2.79 2.89h.12v.32a.85.85 0 1 0 1.7 0v-.32h.38c1.41 0 2.55-1.18 2.55-2.63 0-1.68-.98-2.23-1.73-2.49l-1.2-.42v-2.62h.13c.6 0 1.09.53 1.09 1.19a.85.85 0 1 0 1.7 0c0-1.59-1.25-2.89-2.79-2.89h-.13v-.32a.85.85 0 1 0-1.7 0zm0 4.05-.62-.22c-.41-.14-.59-.24-.59-.89 0-.51.38-.93.85-.93h.36zm1.7 2.39.64.22c.41.15.59.24.59.89 0 .51-.38.93-.85.93h-.38z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const BuyIcon = makeIcon('BuyIcon', BuyIconSvg)
